import React from 'react';
import { BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';
import { PrivateRoute } from 'react-router-keycloak';
import Trips from './pages/trips';
import TripDetails from './pages/tripdetails';
import Header from './components/Header';
import Capacity from './components/Capacity';
import Flights from './components/flights/Flights';
import { StateProvider } from './state';
import Authorization from './AuthorizationProvider';
import CacheBuster from './CacheBuster';
import moment from 'moment-timezone';
import { InstallPrompt } from './components/installPrompt';
moment.tz.setDefault('America/Los_Angeles');

const initialState = {
  theme: { primary: 'green' },
  date: moment(),
  apiDate: moment(),
  showCalendar: false,
  auth_token: false,
  user: '',
  tripStatus: '',
  locationId: 1,
  getRemaining: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'changeDate':
      return {
        ...state,
        date: action.newDate,
      };
    case 'changeApiDate':
      return {
        ...state,
        apiDate: action.newDate,
      };
    case 'showCalendar':
      return {
        ...state,
        showCalendar: action.show,
      };
    case 'changeLocation':
      return {
        ...state,
        locationId: action.id,
      };
    case 'toggleTripStatus':
      return {
        ...state,
        tripStatus: action.status,
      };
    case 'STORE_STRING':
      return {
        ...state,
        auth_token: action.payload,
      };
    case 'ADD_USER':
      return { ...state, ...action.payload };
    case 'UPDATE_GET_REMAINING':
      return { ...state, getRemaining: action.payload };
    default:
      return state;
  }
};

const ConditionalHeader = () => {
  const location = useLocation();
  return location.pathname !== '/flights' ? <Header /> : null;
};

const AppContent = () => (
  <StateProvider initialState={initialState} reducer={reducer}>
    <Router>
      <ConditionalHeader />
      <>
        {/* A <Switch> looks through its children <Route>s and
    renders the first one that matches the current URL. */}
        <Switch>
          <Authorization>
            <PrivateRoute
              path="/tripdetails/:date/:locationId/:pickupSpot/:hour/:minute/:tripListStatus/:driver"
              component={TripDetails}
            />
            <PrivateRoute exact path="/capacity" component={Capacity} />
            <PrivateRoute exact path="/flights" component={Flights} />
            <PrivateRoute exact path="/" component={Trips} />

            {/* <InstallPrompt /> */}
          </Authorization>
        </Switch>
      </>
    </Router>
  </StateProvider>
);

function App() {
  return process.env.NODE_ENV === 'production' ? (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return <AppContent />;
      }}
    </CacheBuster>
  ) : (
    <AppContent />
  );
}

export default App;
